import bFormGroup from './form-group.vue';

export default bFormGroup;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-group/form-group.js
// module id = 494
// module chunks = 0